import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { IUserLogin, UserLogin } from '../../models/user';
import { namespace } from 'vuex-class';
import { AUTHORIZATION_MODULE_NAMESPACE, AUTHORIZATION_AUTHORIZE, AUTHORIZATION_SIGN_IN, AUTHORIZATION_FORGOT_PASSWORD } from '../../store/authorization';
import { Validator } from '../../utils/Validator.util';
import VueRouter from 'vue-router';
import { ActivityStatus } from '../../common/enums';

const AuthorizationStore = namespace(AUTHORIZATION_MODULE_NAMESPACE)

@Component
class Container extends Vue {
  dtForm: boolean;
  dtPasswordMode: string;
  dtError: any;
  dtIsLoading: boolean;
  dtConfirmPasswordMode: string;
  dtSecond: number;
  dtPayload: { action: "resetPwdLong", value: { password: string, confirmedPassword: string, token: string } }
  rules: { require: any, email: any };
  dtRules: {
    passwordRules?: any,
    confirmationPasswordRules?: any
  }
  /**
   *
   */
  constructor() {
    super();
    this.dtError = null;
    this.dtSecond = 0
    this.dtPayload = {
      action: "resetPwdLong",
      value: { password: "", confirmedPassword: "", token: "" }
    }
    this.dtIsLoading = false;
    this.dtForm = false;
    this.dtPasswordMode = "password";
    this.dtConfirmPasswordMode = "password";


    this.dtRules= {}

    this.rules = {
      require: (value: string) => !!value || 'Required.',
      email: (value: string) => Validator.IsValidEmail(value) || 'l\'email n\'est pas valide',
    }
  }
  get password(): string {
    return this.dtPayload.value.password;
  }
  set password(value: string) {
    this.dtPayload.value.password = value
  }
  get confirmedPassword(): string {
    return this.dtPayload.value.confirmedPassword;
  }
  set confirmedPassword(value: string) {
    this.dtPayload.value.confirmedPassword = value
  }
  get lblSetting() {
    return {
      ...require('@/locales/button').default,
      ...require('@/locales/login-form').default,
      ...require('@/locales/validation-messages').default,
    }
  }

  @AuthorizationStore.Action(AUTHORIZATION_FORGOT_PASSWORD)
  storeForgotPassword: (payload: any) => Promise<any>;


  mounted(){
    this.dtRules= {
      passwordRules: [
        v => !!v || this.$t(this.lblSetting.passwordRequired) ,
        v =>  (Validator.isPasswordValid(v) && v.length >= 8) || this.$t(this.lblSetting.passwordValid)
      ],
      confirmationPasswordRules: [
        v => !!v || this.$t(this.lblSetting.passwordRequired),
        v => v === this.password || this.$t(this.lblSetting.passwordMatching)
      ]
    }
  }


  _clearTimeout: any;
  handleRenewPassword() {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {

      if ((this.$refs.renewalFormRef as any).validate()) {
        if (this.notMatched) {
          this.dtError = {
            message: this.$t('LBL_PASSSWORD_NOT_MATCHED')
          }
          return;
        }
      }

      this.dtError = null;
      this.dtIsLoading = true;

      this.dtPayload.value.token = this.$route.query.token;
      this.storeForgotPassword(this.dtPayload)
        .then(res => {
          this.dtIsLoading = false;
          setTimeout(() => {
            this.$router.push('/');
          }, 300);
        })
        .catch(err => {
          this.dtIsLoading = false;
          this.dtError = err;
          this.dtSecond = 3;
          setTimeout(() => {
            if (this.dtSecond >= -1)
              this.dtSecond = this.dtSecond - 1;
          }, 1000);
          setTimeout(() => {
            this.$router.push('/forgot-password')
          }, 4000);
        })
    }, 300);
  }

  get notMatched(): boolean {
    return this.password !== this.confirmedPassword;
  }


  handleShowPassword() {
    this.dtPasswordMode = this.dtPasswordMode === 'password' ? 'text' : 'password'
  }

  handleShowConfirmPassword() {
    this.dtConfirmPasswordMode = this.dtConfirmPasswordMode === 'password' ? 'text' : 'password'
  }
}

export default Container;



// WEBPACK FOOTER //
// ./src/containers/forgot-password-renew/index.ts